import { FILE_UPLOAD_LIMITS, IGNORED_FILENAMES } from "./constants";
import {
	BULK_FILE_UPLOAD_FAILURE,
	RESET_FILE_UPLOAD_FAILURES,
	CLOSE_GLOBAL_SNACKBAR,
} from "../types";

export function validateFileLimit(files, dispatch) {
	if (files.length > FILE_UPLOAD_LIMITS.MAX_FILES) {
		dispatch({
			type: BULK_FILE_UPLOAD_FAILURE,
			payload: {
				message: `Maximum number of files in one upload is ${FILE_UPLOAD_LIMITS.MAX_FILES.toLocaleString()}. You tried to upload ${files.length.toLocaleString()}.`,
				autoHideDuration: null,
			},
		});
		return false;
	}
	return true;
}

export function filterFiles(files) {
	let filteredFiles = [];
	for (let i = 0; i < files.length; i++) {
		let fileName = files[i].name;
		const lowerFileName = fileName.toLowerCase();
		if (
			!IGNORED_FILENAMES.includes(lowerFileName) &&
			!lowerFileName.startsWith("~$")
		) {
			filteredFiles.push(files[i]);
		}
	}
	return filteredFiles;
}

export function prepareForUpload(dispatch) {
	// reset to ensure it has no value at start
	dispatch({
		type: RESET_FILE_UPLOAD_FAILURES,
	});
	// close any old snackbars
	// or new snackbars may not be shown
	dispatch({
		type: CLOSE_GLOBAL_SNACKBAR,
	});
}
